import { assetPackIds } from "nemuru-components";

export const proinsoTheme = {
  themeName: "proinso",
  logoUrl:
    "https://etiamnamene.com/wp-content/uploads/2020/09/Proinso-solar-logo-1-300x115.png",
  palette: {
    primary: {
      main: "#a6cb38",
      contrastText: "#000000",
    },
    secondary: {
      main: "#1d1d1b",
      contrastText: "#fff",
    },
    danger: {
      main: "#ef5957",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "rgba(255, 202, 40, 0.15)",
    },
    info: {
      main: "#999",
      contrastText: "#fff",
      light: "#ededed",
    },
    success: {
      main: "#a6cb38",
      contrastText: "#ffffff",
      light: "rgba(197, 219, 92,0.15)",
    },
    error: {
      main: "#ef5957",
      contrastText: "#ffffff",
      light: "rgba(239,87,87,0.15)",
    },
    text: {
      accent: "#a6cb38",
      title: "#1d1d1b",
      primary: "#000000",
      secondary: "#afafaf",
    },
    dark: {
      main: "#222222",
      accent: "#c5da5c",
      contrastText: "#fff",
      imageBackgroundOpacity: 0.9,
    },
    status: {
      active: "#c5da5c",
      approved: "#9fb04b",
      analysing: "#4FAFDA",
      sent: "#00677e",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  typography: {
    fontFamily: "Lato, sans-serif",
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f6f6f6",
  logo: null,
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 16,
  },
};
